/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
/* eslint-enable no-console */
document.addEventListener("DOMContentLoaded", () => {
	const gus_videos = document.querySelectorAll(".gus-videos");

	gus_videos.forEach((videoBlock) => {
		const checkVideoEmbedURL = videoBlock.getAttribute("data-VideoEmbedURL");
		if (checkVideoEmbedURL) {
			let thumbnails = videoBlock.getElementsByClassName("gus-thumbnail");
			let video_embeds = videoBlock.getElementsByClassName("gus-embed-video");

			for (let i = 0; i < thumbnails.length; i++) {
				thumbnails[i].style.display = "block";
				video_embeds[i].style.display = "none";
			}
			if (thumbnails.length > 0 && video_embeds.length > 0) {
				for (let i = 0; i < thumbnails.length; i++) {
					thumbnails[i].addEventListener("click", () => {
						thumbnails[i].style.display = "none";
						video_embeds[i].style.display = "block";
						let embedIframe = video_embeds[i].querySelector("iframe");
						if (!embedIframe) {
							// Create a new iframe if it doesn't exist
							embedIframe = document.createElement("iframe");
							video_embeds[i].appendChild(embedIframe);
						}
							embedIframe.setAttribute("frameborder", "0");
							embedIframe.setAttribute("title", "myFrame");
							embedIframe.setAttribute("allowfullscreen", true);
							embedIframe.setAttribute(
								"allow",
								"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
							);
							const src = checkVideoEmbedURL; // Use the provided URL
							const url = new URL(src);
							url.searchParams.set("autoplay", "1");
							embedIframe.src = url.toString();
						});
					}
				}
	}
});
});